import { motion } from "framer-motion";
import styled from "styled-components/macro";

import { TitleH1 } from "../../styles/sharedStyles";

type LayerProps = {
  $bleed?: string;
  $image: string;
  $position?: string;
  $zIndex: number;
};

export const Section = styled.section`
  position: relative;
  width: 100vw;
  height: 900px;
  overflow: hidden;
  margin: -100px calc(50% - 50vw) 80px;
  background-color: #07060A;

  @media (max-width: 1439px) {
    height: 912px;
    margin-top: -112px;
  }

  @media (max-width: 1319px) {
    height: clamp(700px, 73.5vw, 740px);
  }

  @media (max-width: 979px) {
    margin-top: 0;
    height: clamp(570px, 73.5vw, 590px);
  }
`;

export const Layer = styled(motion.div)<LayerProps>`
  position: absolute;
  inset: ${({ $bleed = "0px" }) => `-${$bleed} 0`};
  z-index: ${({ $zIndex }) => $zIndex};
  background-image: url(${({ $image }) => $image});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: ${({ $position }) => $position || "center"};
  pointer-events: none;
  opacity: 0.5;

  @media (max-width: 1319px) {
    background-size: auto 90%;
  }
`;

export const LayerBlueLight = styled(Layer)`
  background-size: clamp(1404px, 112.32vw, 2059px) 100%;
  opacity: 1;

  @media (max-width: 1319px) {
    background-size: clamp(1264px, 101.09vw, 1853px) 90%;
  }
`;

export const RocksFrame = styled.div`
  position: absolute;
  z-index: 3;
  left: 50%;
  bottom: -215px;
  width: 2120px;
  height: 1150px;
  max-width: none;
  overflow: hidden;
  transform: translateX(-50%);
  pointer-events: none;

  @media (max-width: 1319px) {
    bottom: -16.29vw;
    width: 160.61vw;
    height: 87.12vw;
    max-width: none;
  }
`;

export const Rocks = styled.img`
  display: block;
  width: 100%;
  height: auto;
  max-width: none;
`;

export const Diamond = styled.img`
  position: absolute;
  z-index: 5;
  left: 50%;
  bottom: 0;
  width: 540px;
  height: auto;
  transform: translateX(-50%);
  pointer-events: none;

  @media (max-width: 1319px) {
    width: 336px;
  }

  @media (max-width: 977px) {
    //bottom: 25px;
  }
`;

export const ShineLeft = styled.img`
  position: absolute;
  z-index: 4;
  left: 170px;
  bottom: 52px;
  width: 440px;
  height: auto;
  pointer-events: none;
  mix-blend-mode: lighten;

  @media (max-width: 1319px) {
    width: 223px;
  }

  @media (max-width: 978px) {
    left: -80px;
    bottom: 20px;
  }
`;

export const ShineRight = styled.img`
  position: absolute;
  z-index: 4;
  right: 170px;
  bottom: 52px;
  width: 440px;
  height: auto;
  pointer-events: none;
  mix-blend-mode: lighten;

  @media (max-width: 1319px) {
    width: 223px;
  }

  @media (max-width: 978px) {
    right: -80px;
    bottom: 20px;
  }
`;

export const HeroContent = styled.div`
  position: relative;
  z-index: 5;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 150px;
  color: #fff;

  @media (max-width: 1439px) {
    padding-top: 150px;
  }

  @media (max-width: 979px) {
    padding-top: 62px;
  }
`;

export const Title = styled(TitleH1)`
  max-width: 945px;
  margin-bottom: 60px;
  color: inherit;

  @media (max-width: 977px) {
    padding-top: 0;
    margin-bottom: 36px;
  }
`;

export const Desc = styled.p`
  max-width: 650px;
  margin-bottom: 60px;
  color: rgba(255, 255, 255, 0.72);
  font-size: 22px;
  font-weight: 400;
  line-height: 140%;
  letter-spacing: -0.02em;
  text-align: center;

  @media (max-width: 977px) {
    margin-bottom: 24px;
    font-size: 16px;
  }
`;

export const ButtonWrapper = styled.div`
  color: #141414;
`;
